/**
 * Adjusts the subinventory information based on the transaction items.
 * Matches each transaction line to its source row by subinventory + row index rather than
 * item/lot/locator: the API can return multiple distinct rows with an identical item/lot/locator
 * triple (lot and locator are often null), so a data-field match would decrement every identical
 * row instead of only the one the user acted on.
 * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput[]} subinventoryInfo - The subinventory information
 * @param {Local.TransactionItem[]} transactionItems - The transaction items
 */
export const adjustSubinventoryInfo = (subinventoryInfo, transactionItems) =>
  subinventoryInfo?.map((item, index) => {
    const allocatedQuantity = transactionItems
      .filter((t) => t.item === item.item && t.subinventoryCode === item.subinventoryCode && t.sourceRowIndex === index)
      .reduce((sum, t) => sum + t.transactionQuantity * -1, 0);

    return {
      ...item,
      unitOfIssueQoh: (item.unitOfIssueQoh || 0) - allocatedQuantity,
    };
  }) ?? [];

/**
 * Map local transaction items to the OrgInvTransaction shape the API accepts.
 * Drops UI-only fields (`id`, `unitOfIssueCode`) that are not part of OrgInvTransaction.
 * @param {Local.TransactionItem[]} items
 * @returns {Local.OrgInvTransaction[]}
 */
export const formatTransactionsForAPI = (items) =>
  items.map((item) => ({
    item: item.item,
    inventoryItemId: item.inventoryItemId,
    organizationId: item.organizationId,
    sourceHeaderId: item.sourceHeaderId,
    sourceLineId: item.sourceLineId,
    transactionSourceTypeId: item.transactionSourceTypeId,
    transactionQuantity: item.transactionQuantity,
    transactionTypeId: item.transactionTypeId,
    transactionUom: item.transactionUom,
    subinventoryCode: item.subinventoryCode,
    transferSubinventory: item.transferSubinventory,
    transferOrganization: item.transferOrganization,
    locatorId: item.locatorId,
    lotNumber: item.lotNumber,
    reasonId: item.reasonId,
    shipToLocationId: item.shipToLocationId,
    distributionAccountId: item.distributionAccountId,
    transactionSourceId: item.transactionSourceId,
    transferLocatorId: item.transferLocatorId,
  }));
